import toast from 'react-hot-toast';
import { useMutation } from 'react-query';
import { useQueryClient } from 'react-query';

import {
  GROUP_SUBSCRIPTION_KEY,
  GiftSubscriptionParams,
  giftSubscription,
} from '../utils/backend-api/groupSubscription';

export default function useGiftSubscriptionCreate(skipSuccessToast) {
  const queryClient = useQueryClient();

  const { mutateAsync, mutate, isLoading } = useMutation(
    (params: GiftSubscriptionParams) => giftSubscription(params),
    {
      onSuccess: () => {
        if (!skipSuccessToast) {
          toast.success('Gift has been purchased successfully');
        }
        queryClient.invalidateQueries([GROUP_SUBSCRIPTION_KEY, 'gift']);
      },
      onError: (errors: string[]) => {
        toast.error(errors.join(';'));
      },
    }
  );
  return { mutateAsync, mutate, isLoading };
}
